// extracted by mini-css-extract-plugin
export default {"root":"Buttons_root__e2J5x","btnView":"Buttons_btnView__lE3Jl","btnDown":"Buttons_btnDown__u1vIF"};